module.exports = __webpack_public_path__ + "img/bandcamp-logo.2330e6ac.png";